import { ActionButtonConfig } from './types';

/**
 * Styling constants for the Message component
 */
export const STYLES = {
  // Container styles
  CONTAINER: {
    MAX_WIDTH: "320px",
    GAP: 2,
  },
  
  // Input field styles
  INPUT: {
    BORDER_RADIUS: "16px",
    BACKGROUND_COLOR: "white",
    VERTICAL_PADDING: "2",
    VERTICAL_MARGIN: "5px",
  },
  
  // Badge styles
  BADGE: {
    BORDER_RADIUS: "full",
    HORIZONTAL_PADDING: 2,
    VERTICAL_PADDING: 1,
    FONT_SIZE: "xs",
    FONT_FAMILY: "Calibri (Body)",
    FONT_WEIGHT: "normal",
  },
  
  // Action button container styles
  ACTION_CONTAINER: {
    MARGIN_RIGHT: "10px",
    MARGIN_LEFT: "10px",
  },
  
  // Input right element positioning
  RIGHT_ELEMENT: {
    RIGHT_OFFSET: "8px",
    TOP_OFFSET: "0",
  },
} as const;

/**
 * Configuration for different action button types
 */
export const ACTION_BUTTON_CONFIGS: Record<string, ActionButtonConfig> = {
  ACCEPT: {
    variant: "link",
    fontSize: "20px",
    minW: "auto",
    h: "auto",
    p: 1,
  },
  DECLINE: {
    variant: "link",
    fontSize: "20px",
    minW: 1,
    h: "auto",
  },
  SHARE: {
    variant: "link",
    fontSize: "20px",
    minW: 1,
    h: "auto",
  },
} as const;

/**
 * Internationalization message keys
 */
export const I18N_KEYS = {
  SHARED_ACCEPTED: "shared.accepted",
  SHARED: "shared",
  ACCEPT: "accept",
  DECLINE: "decline",
} as const;

/**
 * Default messages for internationalization fallbacks
 */
export const DEFAULT_MESSAGES = {
  SHARED: "Shared",
  ACCEPT: "Accept",
  DECLINE: "Decline",
} as const;

/**
 * Query keys for React Query cache invalidation
 */
export const QUERY_KEYS = {
  LIST_INTENTION: "listIntention",
  LIST_SUBLIMINAL: "listSubliminal",
} as const; 